module.exports = "<h2>No 'new' keyword</h2><pre class=\"fragment\"><code class=\"lang-kotlin\">val myList = ArrayList()</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-syntax/01.pug
// module id = 323
// module chunks = 1